import { Injectable, NgZone, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private readonly zone = inject(NgZone);
  private counter = 0;
  private readonly _isLoading = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this._isLoading.asObservable();

  show(): void {
    this.zone.run(() => {
      this.counter++;
      if (this.counter === 1) {
        this._isLoading.next(true);
      }
    });
  }

  hide(): void {
    this.zone.run(() => {
      if (this.counter > 0) {
        this.counter--;
        if (this.counter === 0) {
          this._isLoading.next(false);
        }
      }
    });
  }

  reset(): void {
    this.zone.run(() => {
      this.counter = 0;
      this._isLoading.next(false);
    });
  }
}
